import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ParentProductIdContext } from "@insite/client-framework/Components/ParentProductContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    isAuthenticated: state.context.session.isAuthenticated,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    priceContainer?: InjectableCss;
    msrpContainer?: InjectableCss;
    msrpWrapper?: InjectableCss;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        wrapper: {
            css: css`
                margin-top: 17.33px;
                margin-right: 10px;
                margin-bottom: 17.33px;
            `,
        },
        price: {
            priceText: { size: 24 },
            unitOfMeasureText: { size: 26 },
        },
    },
    priceContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            section {
                width: auto !important;
            }
        `,
    },
    msrpWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            margin: 0 10px 17.33px 0;
            line-height: normal;
        `,
    },
    msrpContainer: {
        css: css`
            color: #bdbdbd;
            font-size:14px;
            margin-right:2px;
        `,
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings, isAuthenticated }) => {
    const parentProductId = React.useContext(ParentProductIdContext);
    return (
        <>
            <StyledWrapper {...styles.priceContainer}>
                <Typography style={{ display: "flex", flexDirection: "row", alignItems: "baseline" }}>
                    <Typography>
                        {isAuthenticated && parentProductId !== productContext.product.id && (
                            <ProductPrice
                                product={productContext}
                                showLabel={false}
                                showSavings={true}
                                showSavingsAmount={productSettings.showSavingsAmount}
                                showSavingsPercent={productSettings.showSavingsPercent}
                                extendedStyles={styles.productPrice}
                            />
                        )}
                        {(productContext.product.productNumber?.toLowerCase().endsWith("-cstd") ||
             productContext.product.productNumber?.toLowerCase().endsWith("-cexp") ||
             productContext.product.productNumber?.toLowerCase().endsWith("-custom"))  && (<StyledWrapper css={css` margin-bottom: 17.33px;`}>&nbsp;</StyledWrapper>)}
                        {productContext?.productInfo?.pricing?.additionalResults?.priceMSRP && !(productContext.product.productNumber?.toLowerCase().endsWith("-cstd") ||
             productContext.product.productNumber?.toLowerCase().endsWith("-cexp") ||
             productContext.product.productNumber?.toLowerCase().endsWith("-custom")) && (
                            <>                                <Typography {...styles.msrpWrapper}>

                                    <Typography {...styles.msrpContainer}>{translate("MSRP:")}&nbsp;</Typography>
                                    <Typography {...styles.msrpContainer}>
                                        {productContext?.productInfo?.pricing?.additionalResults?.priceMSRP}
                                    </Typography>
                                    </Typography>

                            </>
                        )}

                    </Typography>
                    <Typography>
                        {productContext.product.properties.productType === "Rug" && (
                            <Link
                                href="/Catalog/Rugs/Rug-Pads"
                                css={css`
                                line-height:normal !important;
                                    margin: 0 0 17.33px 0px;
                                    text-decoration: underline;
                                    text-decoration-color: rgb(134, 106, 91);
                                `}
                                target="_blank"
                            >
                                {translate("Show Rug Pads")}
                            </Link>
                        )}
                    </Typography>
                </Typography>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;